<div class="user-profile-container">
  <div class="closebutton">
    <app-close-button
      [hasChanges]="false"
      (closed)="appStore.toggleUserProfile()"
    ></app-close-button>
  </div>
  <app-theme-language-selector></app-theme-language-selector>
  <app-profile-edit
    #profileEdit
    [selfUserEdit]="true"
    [showClose]="false"
  ></app-profile-edit>

  <div class="logout-container">
    <button
      mat-button
      (click)="authStore.showLogoutConfirmation()"
      class="logout"
    >
      <mat-icon>logout</mat-icon>
      <p class="logout-text">{{'logout' | translate | async}}</p>
    </button></div
  >
</div>
